import AgentList from './components/AgentList';
import ClassroomList from './components/ClassroomList';
import CoursesList from './components/CoursesList';
import ProfessorInfo from './components/ProfessorInfo';
import { EditLayout } from 'components/layout/layout/EditLayout';
import { Flex, Form, Tabs, Tag } from 'antd';
import { IProfessor } from 'interfaces/professor';
import { PageHeader } from 'components/professor_area/PageHeader';
import { TeamOutlined } from '@ant-design/icons';
import { useCan } from '@refinedev/core';
import { useForm } from '@refinedev/antd';

export const ProfessorEdit = () => {
  const canListClassroomProfessors = useCan({
    resource: 'classroom_professors',
    action: 'list'
  });
  const canListProfessorCourses = useCan({
    resource: 'professor_courses',
    action: 'list'
  });
  const canListAgents = useCan({ resource: 'agents', action: 'list' });

  const { formProps, saveButtonProps, queryResult } = useForm<IProfessor>({
    redirect: 'edit'
  });

  return (
    <EditLayout saveButtonProps={saveButtonProps} title="Editar professor">
      <PageHeader
        title={queryResult?.data?.data?.name}
        icon={TeamOutlined}
        meta={
          <Flex>
            <Tag>{queryResult?.data?.data?.email}</Tag>
          </Flex>
        }
      />

      <Tabs defaultActiveKey="info" className="custom-tabs">
        <Tabs.TabPane tab="Informações Gerais" key="info">
          <Form {...formProps} layout="vertical">
            <ProfessorInfo
              professorData={queryResult?.data?.data}
              type="edit"
            />
          </Form>
        </Tabs.TabPane>
        {canListClassroomProfessors.data?.can && (
          <Tabs.TabPane tab="Responsável por turmas" key="classrooms">
            <ClassroomList />
          </Tabs.TabPane>
        )}
        {canListProfessorCourses.data?.can && (
          <Tabs.TabPane tab="Coordenação de Cursos" key="coordenation">
            <CoursesList />
          </Tabs.TabPane>
        )}
        {canListAgents.data?.can && (
          <Tabs.TabPane tab="Usuário" key="agent">
            <Form {...formProps} layout="vertical">
              <AgentList professorData={queryResult?.data?.data} type="edit" />
            </Form>
          </Tabs.TabPane>
        )}
      </Tabs>
    </EditLayout>
  );
};
